import PropTypes from 'prop-types';
import ImageViewer from '@/components/atoms/ImageViewer';
import {MultiLanguageFieldGroup} from '@/components/molecules';
import ReviewField from './ReviewField';

const RackFields = ({data}) => (
  <>
    <ReviewField label='Header' value={data?.header} />
    <ReviewField label='Subheader' value={data?.subheader} />
  </>
);

RackFields.propTypes = {
  data: PropTypes.object
};

// Banner Label is a stacked list (one language block per row), unlike the
// side-by-side language columns used for Rack Display content.
const BannerLabelReview = ({languages, bannerText}) => (
  <div
    className='flex flex-col gap-4'
    data-testid='perfect-store-review-banner-text'>
    {languages.map((lang) => {
      const data = bannerText?.[lang.code] || {};
      return (
        <div key={lang.code} className='flex flex-col gap-2'>
          <div className='rev_lang'>
            <span className='langBold'>Language: {lang.title}</span>
          </div>
          <ReviewField label='Title' value={data?.title} />
          <ReviewField label='Description' value={data?.description} />
          <hr className='mb-2 border-[color:var(--color-border-divider)]' />
        </div>
      );
    })}
  </div>
);

BannerLabelReview.propTypes = {
  languages: PropTypes.array,
  bannerText: PropTypes.object
};

const PerfectStoreDisplayReview = ({formData = {}, languages = []}) => {
  const displayContent = formData?.displayContent || {};
  const rackDisplays = displayContent?.rackDisplays || [];

  return (
    <div
      className='flex flex-col gap-6'
      data-testid='perfect-store-display-review'>
      <hr className='border-[color:var(--color-border-divider)]' />
      <div className='ml-4'>
        <p className='review-section-label mb-3'>First Position Image</p>
        {displayContent?.bannerImage?.imageUri && (
          <ImageViewer
            url={displayContent.bannerImage.imageUri}
            alt='First Position Image'
          />
        )}
      </div>

      <div className='ml-4'>
        <hr className='mb-2 border-[color:var(--color-border-divider)]' />
        <p className='review-section-label mb-3'>Label</p>
        <BannerLabelReview
          languages={languages}
          bannerText={displayContent?.bannerText}
        />
        <p className='review-section-label mt-3'>Rack Display</p>
      </div>

      {rackDisplays.map((rack, index) => (
        <div className='ml-4' key={rack.id || index}>
          <hr className='mb-2 border-[color:var(--color-border-divider)]' />
          <p className='review-section-label mb-3'>Image {index + 1}</p>
          {rack?.image?.imageUri && (
            <ImageViewer url={rack.image.imageUri} alt={`Image ${index + 1}`} />
          )}
          <hr className='mb-2 mt-2 border-[color:var(--color-border-divider)]' />
          <MultiLanguageFieldGroup
            className='mt-4'
            languages={languages}
            dataTestId={`perfect-store-review-rack-content-${index}`}
            renderField={(lang) => (
              <RackFields data={rack?.content?.[lang.code]} />
            )}
          />
        </div>
      ))}
    </div>
  );
};

PerfectStoreDisplayReview.propTypes = {
  formData: PropTypes.object,
  languages: PropTypes.array
};

export default PerfectStoreDisplayReview;
